import React, { useState } from "react";

export default function ProceduriOperarionalePage() {

    const files = [
    "PO raportare contabil financiar.PDF",
    "PO analiza si stabilirea structurii.PDF",
    "PO control_inregistrarilor_documentelor.PDF",
    "PO gestionarea actelor de studii_doc scola...",
    "PO monitorizare si evaluare PAS.PDF",
    "PO promovare trepte profesionala.PDF",
    "PO_informare_procesul de invatamant_rezu...",
    "PO-C promovarea imaginii UPJ.PDF",
    "PO-SC contral financiar preventiv.PDF",
    "PO-SC intocmire dosar deduceri personal.PDF",
    "PO-SS gestionarea petitiilor si circuitul ace...",

    "PO accesul de mijloacelor de informre_inte...",
    "PO avertizorii in interes public.PDF",
    "PO delegare atributii.PDF",
    "PO intocmire orar.PDF",
    "PO organizare si functionare comisiilor.PDF",
    "PO sanctionare elevi.PDF",
    "PO-C activitati extrascolare.PDF",
    "PO-C promovarea ofertei educationala.PDF",
    "PO-SC executare monitorizare contract.PDF",
    "PO-SC utilizare forexebug.PDF",
    "PO-SS raport de munca .PDF",

    "PO activitati extrascolare.PDF",
    "PO -C elaborare codificare proceduri.PDF",
    "PO determinarea expunerii de risc.PDF",
    "PO intocmire si actualizare fisa de post.PDF",
    "PO planificarea resurselor in vederea ating...",
    "PO servicii pe scoala.PDF",
    "PO-C Comisia CEAC.PDF",
    "PO-SA GDPR.PDF",
    "PO-SC finalizarea contract achizitii publice...",
    "PO-SC voucher de vacanta.PDF",
    "PO-SS reges online.PDF",

    "PO administrare SIIIR.PDF",
    "PO Concurs pe scoala.PDF",
    "PO functii sensibile.PDF",
    "PO monitorizare manuale scolare.PDF",
    "PO practica pedagogica_mentorat.PDF",
    "PO_C organizarea si functionarea comisiilo...",
    "PO-C Gestionare acte de studii si doc sc.PDF",
    "PO-SC caiet de sarcini.PDF",
    "PO-SC garantii participare executie.PDF",
    "PO-SS concedii.PDF",
    ];

 const [visibleCount, setVisibleCount] = useState(5);
 
   const handleShowMore = () => setVisibleCount((prev) => prev + 5);
   const handleShowLess = () => setVisibleCount(5);
 
   return (
     <div className="bg-gray-50">
       <main className="max-w-7xl mx-auto px-4 py-8">
         <h2 className="text-xl font-bold mt-8 mb-4">
           Proceduri Operaționale
         </h2>
 
         <ul>
           {files.slice(0, visibleCount).map((file) => (
             <li key={file} className="mb-3 flex items-center flex-wrap">
               <span className="font-bold text-lg mr-3">
                 {file.replace(".PDF", "")}
               </span>
               <a
                 href={`/documente/hotarariCA/${encodeURIComponent(file)}`}
                 target="_blank"
                 rel="noopener noreferrer"
                 className="text-blue-600 underline"
               >
                 Deschide
               </a>
             </li>
           ))}
         </ul>
 
         <div className="mt-6 flex space-x-4">
           {visibleCount < files.length && (
             <button
               onClick={handleShowMore}
               className="px-4 py-2 rounded transition"
               style={{
                 backgroundColor: "rgba(170,190,107,0.8)",
                 color: "black",
               }}
               onMouseEnter={(e) =>
                 (e.target.style.backgroundColor = "rgba(170,190,107,1)")
               }
               onMouseLeave={(e) =>
                 (e.target.style.backgroundColor = "rgba(170,190,107,0.8)")
               }
             >
               Arată mai multe
             </button>
           )}
 
           {visibleCount > 5 && (
             <button
               onClick={handleShowLess}
               className="px-4 py-2 rounded transition"
               style={{
                 backgroundColor: "red",
                 color: "white",
               }}
               onMouseEnter={(e) => (e.target.style.backgroundColor = "darkred")}
               onMouseLeave={(e) => (e.target.style.backgroundColor = "red")}
             >
               Ascunde
             </button>
           )}
         </div>
       </main>
     </div>
   );
 }
 